export type SlackAPIClientLogLevel = "DEBUG" | "INFO" | "WARN" | "ERROR" | "debug" | "info" | "warn" | "error";
